const EARLY_OUTGOING_STATUSES = new Set([0, 1, 2]);
const TRANSACTION_PROCEEDING = 2;

const hangupHeaderValue = (hangupHeader: string) => hangupHeader.replace(/^X-hangup:\s*/i, '').trim();

const hasHangupHeader = (headers: string[]) => headers.some((header) => /^x-hangup:/i.test(header));

const patchTransactionCancel = (transaction: any, value: string) => {
    if (!transaction || typeof transaction.cancel !== 'function' || transaction.__xHangupCancelPatched) {
        return;
    }

    const originalCancel = transaction.cancel.bind(transaction);
    transaction.cancel = (reason?: string) => {
        const transport = transaction.transport;
        const shouldWrap = transaction.state === TRANSACTION_PROCEEDING
            && transport
            && typeof transport.send === 'function';
        const originalSend = shouldWrap ? transport.send.bind(transport) : null;

        if (shouldWrap) {
            transport.send = (message: any) => {
                transport.send = originalSend;
                if (message?.method === 'CANCEL') {
                    const extraHeaders = Array.isArray(message.extraHeaders) ? message.extraHeaders.slice() : [];
                    if (!hasHangupHeader(extraHeaders)) {
                        extraHeaders.push(`X-hangup: ${value}`);
                    }
                    message.extraHeaders = extraHeaders;
                }
                return originalSend(message);
            };
        }

        try {
            return originalCancel(reason);
        } finally {
            if (shouldWrap && originalSend && transport.send !== originalSend) {
                transport.send = originalSend;
            }
        }
    };
    transaction.__xHangupCancelPatched = true;
};

export const attachHangupHeaderToEarlyCancel = (session: any, hangupHeader: string) => {
    const value = hangupHeaderValue(hangupHeader);
    if (!session || !value || !EARLY_OUTGOING_STATUSES.has(session._status)) {
        return;
    }

    const request = session._request;
    if (request && typeof request.cancel === 'function' && !request.__xHangupCancelPatched) {
        const originalCancel = request.cancel.bind(request);
        request.cancel = (reason?: string) => {
            patchTransactionCancel(request.transaction, value);
            return originalCancel(reason);
        };
        request.__xHangupCancelPatched = true;
    }

    if (typeof session.sendRequest === 'function' && !session.__xHangupByePatched) {
        const originalSendRequest = session.sendRequest.bind(session);
        session.sendRequest = (method: string, options?: {extraHeaders?: string[]}) => {
            if (method === 'BYE') {
                const currentHeaders = options?.extraHeaders;
                const extraHeaders = Array.isArray(currentHeaders) ? currentHeaders.slice() : [];
                if (!hasHangupHeader(extraHeaders)) {
                    extraHeaders.push(`X-hangup: ${value}`);
                }
                return originalSendRequest(method, {...(options || {}), extraHeaders});
            }
            return originalSendRequest(method, options);
        };
        session.__xHangupByePatched = true;
    }
};
